function needsBackspace(currentText, fullText) {
    return (currentText.length > fullText.length ||
        (currentText.length > 0 && !fullText.startsWith(currentText)));
}

export { needsBackspace };
